import React, { useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Form,
  Grid,
  InputMask,
  Row,
  SimpleCollapse,
  SuccessModal
} from 'components'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import { SPACING } from 'utils'
import * as Yup from 'yup'

import { EndPoint } from '../../Consolidation'
import ModalEditConsolidation from '../ModalEditConsolidation/ModalEditConsolidation'
import { AreaTable } from './components/AreaTable/AreaTable'

interface IAreaCollapse {
  listAreas: ISelectedData[]
  add: (data: any, type: EndPoint) => Promise<any>
  edit: (data: any, type: EndPoint) => void
  del: (id: number, type: EndPoint) => void
}
export interface ISelectedData {
  idAreaConsolidacao: number
  dsAreaConsolidacao: string
}

const schema = Yup.object({
  dsAreaConsolidacao: Yup.string().required('Área é um campo obrigatório')
})

const AreaCollapse: React.FC<IAreaCollapse> = ({
  listAreas,
  add,
  del,
  edit
}) => {
  const typeEndpoint = 'A'
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isEditing, toggleIsEditing] = useToggle()
  const [isDeleting, toggleIsDeleting] = useToggle()
  const [selectedData, setselectedData] = useState<ISelectedData | undefined>()

  const handleEdit = (data: any) => {
    edit(
      {
        dsAreaConsolidacao: data.dsAreaConsolidacao,
        idAreaConsolidacao: selectedData.idAreaConsolidacao
      },
      typeEndpoint
    )
    toggleIsEditing()
  }

  const handleSelectData = (objReq: any, type: 'D' | 'E') => {
    setselectedData(objReq)
    if (type === 'E') {
      isEditing === false && toggleIsEditing()
      return
    }

    if (type === 'D') {
      isEditing === false && toggleIsDeleting()
      return
    }
  }

  const handleAdd = (data) => {
    add(data, typeEndpoint).then(() => {
      reset({ dsAreaConsolidacao: '' })
    })
  }

  return (
    <>
      <SimpleCollapse title="Área">
        <Grid
          gridCols="2.5fr 0.4fr 5.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
        >
          <Form onSubmit={handleSubmit(handleAdd)}>
            <Row>
              <InputMask
                label="Área"
                control={control}
                errors={errors}
                formValue="dsAreaConsolidacao"
                placeholder="Digite aqui..."
                maxLength={50}
                type="alfanumeric"
              />
              <Button text="+" type="submit" marginLeft={SPACING.spacing20} />
            </Row>
          </Form>
        </Grid>
        <AreaTable tableData={listAreas} selectedData={handleSelectData} />
      </SimpleCollapse>
      {!!isEditing && (
        <ModalEditConsolidation
          isOpen={isEditing}
          onClose={toggleIsEditing}
          handleEdit={handleEdit}
          formValue="dsAreaConsolidacao"
          initState={selectedData['dsAreaConsolidacao']}
          title="Editar Empresa"
          validationSchema={schema}
        />
      )}
      {!!isDeleting && (
        <SuccessModal
          open={isDeleting}
          message="Tem certeza deseja deletar?"
          type="alert"
          txtButtonCancel="Voltar"
          txtButtonConfirm="SIM"
          handleCancel={toggleIsDeleting}
          handleConfirm={() => {
            del(selectedData.idAreaConsolidacao, typeEndpoint)
            toggleIsDeleting()
          }}
        />
      )}
    </>
  )
}

export default AreaCollapse
